import Subscriptions from "../../Subscriptions";
import {
  getNotificationList,
  updateStatus
  // deleteNotification
} from "./services";
import * as utils from "./utils";

export const subscriptionKeys = {
  cleared: "ats-notification-cleared",
  marked: "ats-notification-marked"
};

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;
    this.utils = utils;
  }

  getNotificationList(query, options) {
    const {promise, cancel} = getNotificationList(query, options);

    const _promise = promise.then(({data /*, headers*/}) => {
      /*
      const {"x-total-hits": totalHits} = headers,
        total = parseInt(totalHits);
      */

      return {
        data,
        metadata: {
          count: data.length,
          total: data.length
        }
      };
    });

    return {promise: _promise, cancel};
  }

  // TODO in the future there will be a batch patch endpoint
  mark(notifications, status = "seen") {
    const toMark =
        typeof notifications === "string" ? [notifications] : notifications,
      promises = [],
      cancels = [];

    toMark.forEach(n => {
      let id = typeof n === "object" ? n.id : n;

      const requestData = {status},
        {promise, cancel} = updateStatus(id, requestData);

      const _promise = promise.then(({data}) => {
        return data;
      });

      promises.push(_promise);
      cancels.push(cancel);
    });

    return {
      promise: Promise.all(promises).then(data => {
        Subscriptions.publish(subscriptionKeys.marked, data);

        return data;
      }),
      cancel: () => {
        cancels.forEach(c => {
          c.cancel();
        });
      }
    };
  }

  clear(notifications) {
    this.mark(notifications, "archived");
  }

  // TODO
  // delete is not part of v1
}

const Configuration = () => {
  if (!window.atsSecurityRibbonNotificationManager) {
    window.atsSecurityRibbonNotificationManager = new Manager();
  }
  return window.atsSecurityRibbonNotificationManager;
};

export default Configuration();

export const ManagerClass = Manager;
